import useGenericEntityStore from '@/layouts/entity/entityStoreModule'

const { storeModule } = useGenericEntityStore('products/suppliers')
export default storeModule
